import Header from "./Header";
import Footer from "./Footer";
import ImageStack from "./ImageStack";
import { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Page = (props) => {
  const innerHeight = useRef();
  const outerHeight = useRef();
  const innerWidth = useRef();
  const outerWidth = useRef();

  const [gridHeight, setGridHeight] = useState(0);
  const [gridWidth, setGridWidth] = useState([]);

  const [dimensions, setDimensions] = useState(0, 0);

  const resizeWindow = () => {
    console.log(dimensions);
    setDimensions(window.innerWidth, window.innerHeight);
    resizeGrid();
  };

  const f = (n) => {
    return (Math.floor(n / 54) + (n % 1: 0)) * 54;
  };

  const fw = (n) => {
    return (Math.floor(n / 54) + (n % 54 ? 1 : 0)) * 52;
  };

  const resizeGrid = () => {
    console.log("resize");
    const h = innerHeight.current?.children[0].clientHeight + 64;
    const height = f(h);
    const blogElement = document.getElementById("blog-container");

    // console.log(innerHeight.current?.clientHeight)
    if (props.shortPage) {
      setGridHeight(height - 108);
      blogElement.style.height = `${height + 100}px`;
    } else {
      setGridHeight(height);
      blogElement.style.height = `${height + 100}px`;
    }

    const w = innerWidth.current?.clientWidth;
    const wi = outerWidth.current?.clientWidth;
    let width;
    let widthI;

    if (window.innerWidth < 760) {
      width = fw(w);
      widthI = fw(wi);
    } else {
      width = f(w);
      widthI = f(wi);
    }

    setGridWidth([width, widthI]);
  };

  useEffect(() => {
    // remove formitable widget if not on resto page
    if (props.headerTitle !== "Restaurant DS") {
      document.querySelector("#formitableWidget")?.remove();
    }
  }, [props.headerTitle]);

  useEffect(() => {
    // if (window.innerWidth > 1200) {
    // console.log('effect', gridHeight)
    // const h = innerHeight.current?.children[0].clientHeight + 64;
    // const height = f(h);
    // console.log(0, height)
    outerHeight.current.style.height = gridHeight;
    if (window.innerWidth > 1200) {
      innerHeight.current.style.height = gridHeight - 2;
    } else {
      innerHeight.current.style.height = gridHeight;
    }

    // } else {
    //   const h = innerHeight.current?.clientHeight;
    //   const height = f(h);
    //   outerHeight.current.style.height = height - 1;
    //   innerHeight.current.style.height = height;
    //   setGridHeight(height)
    // }

    // console.log(innerWidth.current.clientWidth)

    // alert(`${gridWidth}`)
    if (innerWidth.current !== undefined && outerWidth.current !== undefined) {
      innerWidth.current.style.width = gridWidth[0];
      outerWidth.current.style.width = gridWidth[1];
    }

    // innerWidth.current.style.width = gridWidth[0]
    // outerWidth.current.style.width = gridWidth[1]
  }, [gridHeight, gridWidth]);

  const fadeInImage = () => {
    setTimeout(() => {
      document
        .querySelector(".img-opacity")
        .children[0].classList.remove("lazyloading");
    }, 200);
  };

  useEffect(() => {
    resizeGrid();
  }, [props.langNL, props.toggleTeam, props.content]);
  useEffect(() => {
    fadeInImage();
  }, []);
  useEffect(() => {
    resizeWindow();
    window.addEventListener("resize", resizeWindow);
    return () => window.removeEventListener("resize", resizeWindow);
  }, []);

  // useEffect(() => {resizeGrid();},[props.langNL])

  // if (window.innerWidth > 1200) {
  //    outerHeight.current.style.height = gridHeight;
  //    innerHeight.current.style.height = gridHeight - 2;
  //  } else {
  //    outerHeight.current.style.height = gridHeight - 1;
  //    innerHeight.current.style.height = gridHeight;
  //  }

  // window.addEventListener('resize', resizeGrid)

  // console.log("gridheight", outerHeight.current?.children[0].clientHeight);
  return (
    <div>
      <Header
        langNL={props.langNL}
        changeLang={props.changeLang}
        resizeGrid={resizeGrid}
      />
      <div className="grid__container">
        <div className="grid__wrapper">
          <div className="grid grid__top grid-home"></div>
        </div>
      </div>
      <section className="info__container" id="blog-container">
        <div className="info__container-header page__info">
          <div className="page__header">
            <h1 className="page__header-title page__info">
              <span className="ff">{props.headerTitle}</span>
              {props.headerTitle === "Team DS" && (
                <>
                  <div
                    className="navigation__trigger js-navigation-trigger ff teams__navigation-trigger"
                    style={{ marginTop: "19px", marginRight: "-12px" }}
                    onClick={props.toggleMenu}
                  >
                    {!props.langNL && props.team === "kantoor"
                      ? "office"
                      : props.team}
                  </div>
                  <nav className="navigation__container teams__navigation">
                    <div
                      className="navigation__item ff undercase"
                      onClick={() => {
                        props.toggleTeam("club");
                        props.toggleMenu();
                      }}
                    >
                      club
                    </div>
                    <div
                      className="navigation__item ff undercase"
                      onClick={() => {
                        props.toggleTeam("restaurant");
                        props.toggleMenu();
                      }}
                    >
                      restaurant
                    </div>
                    <div
                      className="navigation__item ff undercase"
                      onClick={() => {
                        props.toggleTeam("cafe");
                        props.toggleMenu();
                      }}
                    >
                      Café
                    </div>
                    {/*<div className="navigation__item ff undercase" onClick={() => {props.toggleTeam('gym');props.toggleMenu()}}>gym</div>*/}
                    <div
                      className="navigation__item ff undercase"
                      onClick={() => {
                        props.toggleTeam("kantoor");
                        props.toggleMenu();
                      }}
                    >
                      {props.langNL ? "kantoor" : "office"}
                    </div>
                  </nav>
                </>
              )}
            </h1>

            <div className="page__header-pattern dots__pattern page__info"></div>
            {props.routeTitle && (
              <div
                className="page__header-extra-title calc-width page__header-extra-title--2"
                ref={innerWidth}
              >
                <Link
                  to={props.routeLink}
                  className="page__header-extra-title-link ff"
                  title=""
                >
                  {props.routeTitle}
                </Link>
              </div>
            )}

            {props.extraTitle && (
              <div
                className="page__header-extra-title calc-width page__header-extra-title--2"
                ref={innerWidth}
              >
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={props.extraTitleLink}
                  className="page__header-extra-title-link ff"
                  title=""
                >
                  {props.extraTitle}
                </a>
              </div>
            )}

            {props.extraTitleOne && (
              <div
                className="page__header-extra-title calc-width"
                ref={outerWidth}
                style={{ width: gridWidth[1] }}
              >
                {props.extraTitleOneLink ? (
                  <a
                    href={props.extraTitleOneLink}
                    target="_blank"
                    rel="noreferrer"
                    className="page__header-extra-title-link ff"
                    title=""
                  >
                    {props.extraTitleOne}
                  </a>
                ) : (
                  <h4>{props.extraTitleOne}</h4>
                )}
              </div>
            )}
          </div>

          {/*!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!*/}

          {/* {props.headerTitle === 'Team DS' ?
         <div className="info__grid-title info__team-image">
          <div className="ff">{props.description}
          </div>

        </div>
       :*/}
          <div className="info__grid-title">
            <div className="ff">{props.description}</div>
          </div>

          {/* }*/}

          {/*!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!*/}
        </div>

        {props.image && (
          <div className="page__container-wrapper">
            <div className="info__grid-image img-opacity">
              <ImageStack image={props.image} />
            </div>
          </div>
        )}

        {props.outsideContent ? (
          <div
            className="info__container-content-grid page__blog"
            ref={outerHeight}
          >
            <div
              className="info__container-content calc-height page__info"
              ref={innerHeight}
            >
              <div className="info__content-description">
                <div className="info__content-description-info ff">
                  {props.content}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            className="info__container-content-grid page__info"
            ref={outerHeight}
          >
            <div
              className="info__container-content calc-height page__info"
              ref={innerHeight}
            >
              <div className="info__content-description">
                <div className="info__content-description-info ff">
                  {props.content}
                </div>
              </div>
            </div>
          </div>
        )}

        {props.outsideContent && props.outsideContent}
      </section>

      <Footer isNL={props.langNL} />
      <div id="outdated">
        <h6>Your browser is out-of-date!</h6>
        <p>
          Update your browser to view this website correctly.
          <a id="btnUpdateBrowser" href="http://outdatedbrowser.com/">
            {" "}
            Update my browser now
          </a>
        </p>
      </div>

      {props.headerTitle === "Restaurant DS" && (
        <div
          id="formitableWidget"
          className="ft-widget-b2 ft-w-page-suggested ft-vouchers-active ft-w-recommended-0 show-redeem"
          data-restaurant="f6a3b51d"
          data-open="1500"
          data-open-mobile="false"
          data-color="#121111"
          data-language={props.langNL ? "nl" : "en"}
          data-tag="Website"
          data-toolbar="true"
          data-toolbar-mobile="true"
          data-rendered=""
        >
          <iframe
            title="formitableWidget"
            src="https://widget.formitable.com/side/en/f6a3b51d/book?paymentProvider=Mollie&amp;
      toolbar=true&amp;mobileToolbar=true&amp;tag=Website&amp;
      color=%23121111&amp;preview=false"
            scrolling="no"
            frameBorder="0"
            style={{ height: "100%", width: "100%" }}
          ></iframe>
        </div>
      )}
    </div>
  );
};

export default Page;
